var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
export default (function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? '' : _b, rest = __rest(_a, ["fill"]);
    return (_jsx("svg", __assign({ width: "24", height: "28", viewBox: "0 0 24 28", fill: fill, xmlns: "http://www.w3.org/2000/svg" }, rest, { children: _jsx("path", { d: "M12.0007 14.0003C15.6827 14.0003 18.6673 11.0155 18.6673 7.33366C18.6673 3.65184 15.6827 0.666992 12.0007 0.666992C8.31898 0.666992 5.33398 3.65184 5.33398 7.33366C5.33398 11.0155 8.31898 14.0003 12.0007 14.0003ZM14.6394 16.5003H9.3619C4.37612 16.5003 0.333984 20.5421 0.333984 25.528C0.333984 26.5252 1.14247 27.3337 2.1394 27.3337H21.8619C22.8588 27.3337 23.6673 26.5252 23.6673 25.528C23.6673 20.5421 19.6255 16.5003 14.6394 16.5003Z", fill: fill }) })));
});
